var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Transform } from 'class-transformer';
export class ContentObjectModel {
    id;
    elkAppId;
    name;
    description;
    type;
    importedObjectId;
    creatorAccountId;
    contentData;
    status;
    createDate;
    updateDate;
    updateDataDate;
    tags;
}
__decorate([
    Transform(definition => JSON.stringify(JSON.parse(definition), null, 2), { toClassOnly: true }),
    __metadata("design:type", String)
], ContentObjectModel.prototype, "contentData", void 0);
//# sourceMappingURL=ContentObject.js.map